import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

class ReactDatePicker extends React.Component {
  render() {
    return (
      <DatePicker
        className="css-input-react-datepicker"
        selected={this.props.visitDate}
        onChange={this.props.handleChangeVisitTime}
        isClearable
        showTimeSelect
        timeFormat="HH:mm"
        timeCaption="time"
        timeIntervals={30}
        dateFormat="dd/MM/yyyy HH:mm"
        dayClassName={(date) =>
          this.props.visit_days_unavailable.find(
            (d) =>
              moment(d).format("YYYY-MM-DD") ===
              moment(date).format("YYYY-MM-DD")
          )
            ? "visit-date-unavailable"
            : ""
        }
        //excludeDates={visit_days_unavailable}
        minDate={new Date()}
        minTime={new Date(0, 0, 0, 9, 0)} // 9h
        maxTime={new Date(0, 0, 0, 20, 0)} // 20h
        placeholderText="Indique a data da visita"
      />
    );
  }
}

export default ReactDatePicker;
